import moment from 'moment';

export const DateFormat = 'MM/DD/YYYY';
export const DateFormatDisplay = 'MMMM DD, YYYY';
export const DateFormatDisplayShort = 'MMM DD, YYYY';

export const TimeFormat = 'HH:mm';
export const TimeFormat12 = 'hh:mm a';

export const DateTimeFormatDisplay = 'MM/DD/YYYY HH:mm A';

/**
 * Get date display
 * @param {string|date|moment} value
 * @param {string} languageCode
 */
export const getDateDisplay = (value: string, dateFormat: string = DateFormat) => {
  return moment(value).format(dateFormat);
};

/**
 * Get date display
 * @param {string|date|moment} value
 * @param {string} languageCode
 */
export const getTimeDisplay = (value: string, timeFormat: string = TimeFormat) => {
  return moment(value).format(timeFormat);
};

/**
 * Get request format
 * @param {string|date|moment} value
 * @param {string} languageCode
 */
export const getRequestFormat = (value: string | Date) => {
  return moment(value).toISOString();
};
